import ApiService from "./api.service";
export default class DomainService extends ApiService {
    static base_url = `${super.base_url}/domains`;
}
